import { useState } from "react";
import { useRouter } from "next/router";

const useZipmeLink = () => {
  const router = useRouter();
  const [zipmeLink, setZipmeLink] = useState<string>("");
 
  const generateLink = (externalLink: string) => {
    if (!externalLink) {
      console.warn("No external link provided!");
      return;
    }
 
    if (!router.isReady) return;
 
    const queryString = router.asPath.split("?")[1];
    const newLink = queryString ? `${externalLink}?${queryString}` : externalLink;
 
    setZipmeLink(newLink);
    window.open(newLink, "_blank");
  };
 
  return { zipmeLink, generateLink };
};

export default useZipmeLink;
